import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { RULE_REC_TYPE } from '../../../../constants';
import { browserIsolationLicense } from '../../../../productLicense';
import ConsoleStore from '../../../../stores/ConsoleStore';
import PolicyStore from '../../../../stores/Policy/PolicyStore';
import DlpRuleName from './DlpRuleName';
import FileRules from '../FileRules';
import { Card, FTBody, FTHeading } from '../../../Fuse';
import StackL from '../../../Spacers/Spacers';
import { TStrong } from '../../../Text/Text';
import { FuseConsoleCardFooter } from '../../../ConsoleFragments';

class DlpRules extends Component {
    static propTypes = {
        policy: PolicyStore.PropType.isRequired,
        console: ConsoleStore.PropType.isRequired
    };

    renderAboutSection = () => {
        return <Card title="What are Data Loss Prevention (DLP) Rules?">
            <FTBody>
                File DLP Rules can either block or allow uploads and downloads in Isolation based on specific criteria
                designed to mitigate the risk of sensitive data sharing.
            </FTBody>
            <StackL />
            <FTBody>
                <b>NOTE:</b> File DLP Rules only apply to files that are not blocked by an existing File Threat Rule.
            </FTBody>
            <StackL />
            <FTHeading>When are File DLP Rules Applied?</FTHeading>
            <StackL />
            <FTBody>
                If your File Threat Rules did not block the file operation, the system will then evaluate
                your File DLP Rules. The highest-ranking File DLP rule that matches will be applied.
            </FTBody>
            <StackL />
            <FTHeading>How to Use File DLP Rules</FTHeading>
            <StackL />
            <FTBody><TStrong>Step 1. Edit the Default File DLP Rule</TStrong></FTBody>
            <StackL />
            <FTBody>
                This establishes the baseline file settings for all uploads and downloads in Isolation. The Default DLP
                Rule applies to all files, is always enabled, and always operates at the lowest priority.
            </FTBody>
            <StackL />
            <FTBody><TStrong>Step 2. Add new File DLP Rules</TStrong></FTBody>
            <StackL />
            <FTBody>
                Name the Rule, then specify its Match Criteria and Action. This is how you create exceptions to the
                Default File DLP Rule.
            </FTBody>
            <StackL />
            <FTBody>
                <b>NOTE:</b> Added File DLP Rules can match with your existing or newly defined DLP detector sets,
                which are managed in Proofpoint’s dedicated DLP application. Make sure your detectors and
                detector sets are defined before creating DLP Rules that scan files.
            </FTBody>
            <StackL />
            <FTBody><TStrong>Step 3. Stack-rank File DLP Rules in the Console </TStrong></FTBody>
            <StackL />
            <FTBody>
                Rules are applied based on priority. Only the highest-ranking Rule with matching criteria is applied.
                This allows you to create Rules with specific exemptions that will override more broad Rules.
            </FTBody>
            <StackL />
            <FTHeading>Common Use Case</FTHeading>
            <StackL />
            <FTBody>
                Prevent Data Exfiltration from file upload and download operations within Isolation.
            </FTBody>
            <StackL />
            <FuseConsoleCardFooter
                text={`If no File DLP Rules are added, the system assigns the default File DLP Rule for all uploads and
                downloads allowed in Isolation.`}
            />
        </Card>;
    }

    render() {
        return <FileRules
            showDetectorSetsCondition
            // Page is hidden from the menu, but in case someone access it directly
            // Disable because no-one but browser iso users can use or access our DLP rules
            readOnly={this.props.console.license !== browserIsolationLicense}
            scanFileSize={100}
            fileScanType={'DLP'}
            scanLabel={'DLP Scan'}
            store={this.props.policy.dlpRules}
            itemNameFull={'File DLP Rule'}
            ruleType={RULE_REC_TYPE.DLP_RULES}
            renderName={({ name, isDefault }) => <DlpRuleName name={name} isDefault={isDefault} />}
            sourceCountriesName={'User'}
            tableSubHeaderText={'File DLP Rules only apply to files that are allowed by an existing File Threat Rule.'}
        >
            {this.renderAboutSection()}
        </FileRules>;
    }
}

export default inject('policy', 'console')(observer(DlpRules));
